import React, {Component} from 'react';
import PropTypes from 'prop-types'

import styled from 'styled-components'

import Calendar from 'react-calendar/dist/entry.nostyle'

import {Backdrop, Block, Overlay, Portal} from "reakit";
import {Box, Flex, Heading, Image, Text} from 'rebass';
import IosArrowBack from 'react-ionicons/lib/IosArrowBack'
import Waves from './Waves'
import chevronRight from "../../resources/img/icons/Chevron_2@1x.png";
import activeCircle from '../../resources/img/icons/wave-calendar-circle.png'

import MdArrowDropright from 'react-ionicons/lib/MdArrowDropright'
import MdArrowDropleft from 'react-ionicons/lib/MdArrowDropleft'

const FilterOverlay = styled(Overlay)`
width: 100%;
margin: 0;
padding: 0;
height: 100%;
`;


const CalenderWrapper = styled(Box)`
  //width: 100vw;

  & * {
  color: white;
  //border: none;
  padding: 2px;
  }
  .react-calendar {
    &, & *, & *:before, & *:after {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
   }
   button {
    margin: 0;
    border: 0;
    outline: none;

    &:enabled {
      &:hover {
        cursor: pointer;
        }
      }
    }
    &__navigation {
	    height: 44px;
	    margin-bottom: 1em;
	    
	    //&__next-button {
	    //	margin-left: -50px;
	    //}
	    //
	    //&__prev-button {
	    //	margin-left: -50px;
	    //}
	    &__next2-button {
						visibility: hidden;
				}
				
			&__prev2-button {
					visibility: hidden;
			}
	
	    button {
	      min-width: 44px;
	      background: none;
	      font-size: 17px;
	      font-weight: 500;
	
	      &:enabled {
	        &:hover, &:focus {
	          //background-color: rgb(230, 230, 230);
	        }
	      }
	
	      &[disabled] {
	        background-color: rgb(240, 240, 240);
	      }
	    }
  }
  
    &__month-view {
    &__weekdays {
      text-align: center;
      text-transform: uppercase;
      font-weight: bold;
      font-size: .75em;
      abbr {
      color: #969a9b;
      text-decoration: none;
      }
			
      &__weekday {
        padding: .5em;
      }
    }

    &__weekNumbers {
      font-weight: bold;

      .react-calendar__tile {
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: .75em;
        padding: calc(.75em / .75) calc(.5em / .75);
      }
    }

    &__days {
      &__day {
        &--weekend {
          color: red;
        }

        &--neighboringMonth {
          color: rgb(150, 150, 150);
        }
      }
    }
  }

  &__year-view,
  &__decade-view,
  &__century-view {
    .react-calendar__tile {
      padding: 2em .5em;
    }
  }
  
    &__tile {
    max-width: 100%;
    text-align: center;
    padding: .75em .5em;
    background: none;
    &:disabled {
      background-color: rgb(240, 240, 240);
    }

    &:enabled {
      &:hover, &:focus {
        //background-color: rgb(230, 230, 230);
      }
    }

    &--hasActive {
  		border-radius: 50px;
      // background-image: url(${activeCircle});
      background-repeat: no-repeat;
      background-position: center;
      color: #263039;


      &:enabled {
        &:hover, &:focus {
          background: blue;
        }
      }
    }
     &--active {
      background-image: url(${activeCircle});
      background-repeat: no-repeat;
      background-position: center;
      color: #263039;
      
      abbr {
      			//background-color: white;
      			border-radius: 50px;
      			padding: 6px;
      			min-width: 28px;
      			//padding-right: 5px;
            color: #263039;

      	}
      }

      &:enabled {
        &:hover, &:focus {
          background: lighten(rgb(0, 110, 220), 10%);
        }
      }
    }
    &--selectRange {
    .react-calendar__tile {
      &--hover {
        background-color: rgb(230, 230, 230);
      }
    }
  }
  }
`;


class MobileWaves extends Component {

	state = {
		date: new Date(),
		gender: '',
		grade: '',
		dorm: '',
		location: '',
		type: ''
  };
  
  componentDidMount() {
    const {profile} = this.props;
    this.setState({ student: profile });
    let today = new Date();
    today.setHours(0,0,0,0);
    this.fetchWaveHistory(today.getTime()/1000);
  }

	handleSelect = () => {
		//console.log('select')
	};

	onChange = (date) => {
    this.setState({date})
    let startDate = date.getTime()/1000;
    this.fetchWaveHistory(startDate);
  }
  
  fetchWaveHistory = async (date) => {
    const {data} = this.props;

    let startDate = date;
    let endDate = date + 86400;
    let waveResult = [];
    let waveRef = await this.props.firebase.student(data.id).collection('wave_history').where('post_time', '>=', startDate).where('post_time', '<', endDate).get();
    waveRef.docs.forEach(doc => waveResult.push({id: doc.id, ...doc.data()}));

    for(let i in waveResult) {
      let creator;
      if (waveResult[i].creator_uid === data.id) {
        creator = data;
      }
      else {
        let faculty = false;
        await this.props.firebase.faculty(waveResult[i].creator_uid).get().then(snapshot => {
          if (snapshot.exists) {
            creator = {id: snapshot.id, ...snapshot.data()};
            faculty = true;
          }
        });
        if (!faculty) {
        await this.props.firebase.student(waveResult[i].creator_uid).get().then(snapshot => {
            if (snapshot.exists) {
              creator = {id: snapshot.id, ...snapshot.data()};
            }
          });
        }
      }
      waveResult[i].creator = creator;
    }
    this.setState({
      student: {
        wave: waveResult
      }
    }) 
  }

	render() {
		const {date, student} = this.state;
		const {locations, leaveTypes, data} = this.props;
		return (
			<Overlay.Container>
				{overlay => (
					<Block>
						<Flex onClick={overlay.show} {...overlay}>
							<Box><Text  fontWeight={600}>{data && data.first_name}'s Wave History</Text></Box>
							<Box mr={'auto'}/>
							<Box><Image src={chevronRight}/> </Box>
						</Flex>

						<Backdrop use={[Portal, Overlay.Hide]} {...overlay} />
						<FilterOverlay use={Portal} {...overlay} >
							{overlay.visible &&
							<Box>
								<Box bg={"#263039"}>
									<Box p={2}>
										<IosArrowBack fontSize={'30px'} color={'white'} onClick={overlay.hide}/>

										<Heading color={'white'} as={'h5'} m={0} pl={2}>Wave History</Heading>
									</Box>
									<CalenderWrapper bg={'#263039'} color={'white'} width={1}>
										<Calendar
											onChange={this.onChange}
											value={this.state.date}
											tileClassName={this.handleTileClassNames}
											showNeighboringMonth={false}
											prevLabel={<MdArrowDropleft color={'white'} fontSize={'20px'}/>}
											nextLabel={<MdArrowDropright color={'white'} fontSize={'20px'}/>}
										/>
									</CalenderWrapper>
								</Box>


								<Waves student={student} locations={locations} leaveTypes={leaveTypes} date={date}/>

							</Box>}
						</FilterOverlay>
					</Block>
				)}
			</Overlay.Container>
		)
	}
}

MobileWaves.propTypes = {
	profile: PropTypes.object
};

MobileWaves.defaultProps = {
	profile: {first_name: '', last_name: ''}
};


export default MobileWaves
